const links = {
  signIn: '/sign-in',
  dashboard: '/dashboard',
  order: '/order/:id',
  certificate: '/certificate/:token',
};

const healthCheckLinks = {
  ...links,
};

export default healthCheckLinks;
